"use client";

import { getSectionStyle } from "@/utils";
import { getS3ImageUrl } from "@/utils/routes";
import Image from "next/image";
import { CSSProperties, useMemo } from "react";
import classes from "./Services.module.css";

interface Props {
  className?: string;
  style?: CSSProperties;

  widget?: Widget;
}

const Services = ({
  className,
  style,

  widget,
}: Props) => {
  const classNames = [classes.Services, className];

  const serviceTabs = useMemo(
    () => widget?.data?.tabs || [],
    [widget?.data?.tabs]
  );

  if (!serviceTabs.length) return null;

  const settings = widget?.data?.settings || {};

  return (
    <div className={classNames.join(" ")} style={getSectionStyle(settings)}>
      <div className={`${classes.container} container`}>
        <div className={classes.tabs}>
          {serviceTabs.map((tab, index) => (
            <div key={index} className={`${classes.tab}`}>
              {tab.logo && (
                <Image
                  src={getS3ImageUrl(tab.logo || "")}
                  width={36}
                  height={36}
                  alt={tab.name?? 'service logo'}
                  objectFit="contain"
                  unoptimized={true}
                  className={classes.logo}
                />
              )}
              <p className={classes.name}>{tab.name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
